import { useMemo } from 'react'
import { APPLICATION_SETTINGS } from '../../../common/constants'
import { projectGeneralViewData } from '../../../common/views/projectViewData'

export const useProjectGeneralViewData = (data) => {
    const appSettings = useMemo(
        () => ({
            currency: APPLICATION_SETTINGS.CURRENCY,
            lang: APPLICATION_SETTINGS.DEFAULT_LANGUAGE,
            areaUnit: APPLICATION_SETTINGS.AREA_UNIT,
        }),
        []
    )

    return useMemo(() => projectGeneralViewData(data, appSettings), [data, appSettings])
}
